import { z } from 'zod'

export const webhookDeliverySummary = z
    .object({
        status: z.enum(['success', 'failed']),
        test: z.boolean(),
        httpStatus: z.number().nullable(),
        errorMessage: z.string().nullable(),
        deliveredAt: z.coerce.date().nullable(),
    })
    .nullable()

export const webhook = z.object({
    id: z.string(),
    url: z.string(),
    eventType: z.string(),
    active: z.boolean(),
    lastDeliveredAt: z.coerce.date().nullable(),
    createdAt: z.coerce.date(),
    latestDelivery: webhookDeliverySummary.optional(),
})

export const webhookWithSecret = z.object({
    webhook,
    secret: z.string(),
})

export const webhookDelivery = z.object({
    id: z.string(),
    eventType: z.string(),
    test: z.boolean(),
    status: z.enum(['success', 'failed']),
    httpStatus: z.number().nullable(),
    requestPayload: z.string(),
    responseBody: z.string().nullable(),
    errorMessage: z.string().nullable(),
    attempt: z.number(),
    deliveredAt: z.coerce.date().nullable(),
    createdAt: z.coerce.date(),
})

export type Webhook = z.infer<typeof webhook>
export type WebhookWithSecret = z.infer<typeof webhookWithSecret>
export type WebhookDelivery = z.infer<typeof webhookDelivery>
